<div class="pcs-container">
  <div class="pcs-header">
    <h3 class="pcs-title">Bulk Upload - Forms</h3>
    @if (fromFormsManagement && isAdminOrSystem()) {
    <div class="header-actions">
      <button
        (click)="returnToFormsManagement()"
        mat-flat-button
        color="primary"
        type="button"
      >
        <mat-icon>arrow_back</mat-icon> Return to Forms Management
      </button>
    </div>
    }
  </div>

  <form [formGroup]="form" class="bulk-upload-form">
    <div class="provider-disclaimer-row">
      <div class="custom-form-field">
        <label for="organizationId">{{ organizationLabel }}<span class="required">*</span></label>
        <mat-form-field appearance="outline" class="custom-field">
          <mat-select formControlName="organizationId" name="organizationId">
          <div class="options-container" #optionsContainer>
            @for (provider of providersList; track provider) {
              <mat-option [value]="provider.id">{{ provider.name }}</mat-option>
            }
          </div>
          </mat-select>
          <mat-icon matSuffix>expand_more</mat-icon>
          @if (form.controls['organizationId'].errors?.['required']) {
            <mat-error>Please select {{ organizationLabel }}</mat-error>
          }
        </mat-form-field>
      </div>

      <p class="disclaimer-text">
        Uploaded forms will be available as soon as processing completes. Information is tagged through an automated process. Please review the information for accuracy.
      </p>
    </div>

    <div class="form-upload-container">
      <p>Please upload documents<span class="required">*</span></p>
      <app-bulk-upload-documents
        [submitDisabled]="isSubmitDisabled()"
        [submitLoading]="isLoading"
        [submitText]="'Submit'"
        [organizationType]="organizationType()"
        (uploadingEvent)="uploadingEventHandler($event)"
        (onFileRemove)="onFileRemoveHandler($event)"
        (onSubmit)="onSubmit()"
      ></app-bulk-upload-documents>
    </div>
  </form>
</div>
